import Vue from 'vue'
import App from './App.vue'
// import directives from './directive/directives'
import { commonMixin } from '@/mixins/mixins'
import { removeAllPagePositions } from '@/utils/pagePosition'
import MuseUI from 'muse-ui' // museUI
import Helpers from 'muse-ui/lib/Helpers' // 工具类 过渡动画、四个指令、波纹效果
import VueClipboard from 'vue-clipboard2' // 复制
import Loading from 'muse-ui-loading' //muse Loading
import Toast from 'muse-ui-toast' //muse Loading
import Message from 'muse-ui-message'
import './assets/js/common'

import {
    Badge,
    Button,
    Cell,
    Checkbox,
    Col,
    DatetimePicker,
    Dialog,
    DropdownItem,
    DropdownMenu,
    Empty,
    Field,
    Form,
    Icon,
    Image,
    Lazyload,
    List,
    Loading as VatLoading,
    Overlay,
    Picker,
    Popover,
    Popup,
    PullRefresh,
    Row,
    Search,
    Sticky,
    Swipe,
    SwipeCell,
    SwipeItem,
    Switch,
    Tab,
    Tabbar,
    TabbarItem,
    Tabs,
    Tag,
    Uploader,
    Stepper,
    RadioGroup,
    Radio,
    TreeSelect
} from 'vant'
import { getParams, setToken, TOKEN_KEY } from './assets/js/util'
import router from './routes'
import store from './store/store'

// 使用自定义主题
import myTheme from './assets/lib/muse-theme/theme'

Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(DatetimePicker)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Sticky)
Vue.use(List)
Vue.use(Col)
Vue.use(Row)
Vue.use(PullRefresh)
Vue.use(Uploader)
Vue.use(Image)
Vue.use(Lazyload)
Vue.use(Icon)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(VatLoading)
Vue.use(Search)
Vue.use(Cell)
Vue.use(Switch)
Vue.use(Empty)
Vue.use(Tag)
Vue.use(Overlay)
Vue.use(Popover)
Vue.use(Badge)
Vue.use(SwipeCell)
Vue.use(Dialog)
Vue.use(Stepper)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(TreeSelect)

if (process.env.VUE_APP_ENV == 'test') {
    // 如果是非线上环境，加载 VConsole
    const VConsole = require('vconsole')
    new VConsole()
    // 开启性能追踪
    Vue.config.performance = true
}

MuseUI.theme.add('myTheme', myTheme).use('myTheme')

// Toast配置
const opt = {
    position: 'bottom', // 弹出的位置
    time: 3000, // 显示的时长
    closeIcon: 'close', // 关闭的图标
    close: true, // 是否显示关闭按钮
    successIcon: 'check_circle', // 成功信息图标
    infoIcon: 'info', // 信息信息图标
    warningIcon: 'priority_high', // 提醒信息图标
    errorIcon: 'warning' // 错误信息图标
}
Toast.config(opt)
Vue.use(MuseUI) // 使用MuseUI框架
Vue.use(Helpers) // 工具类 过渡动画、四个指令、波纹效果
Vue.use(Loading) // 挂载Loading组件 let loading = this.$loading | let loading= Loading({})  loading.close()  API:https://muse-ui.org/#/zh-CN/loading
Vue.use(Toast) // 挂载Toast组件
Vue.use(Message)
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

Vue.config.productionTip = false

const token = getParams(window.location.href)[TOKEN_KEY] || ''
if (token) {
    // 存token
    setToken(token)
    // localStorage.setItem('token', token);
}

Vue.mixin(commonMixin)

const app = new Vue({
    router,
    store,
    render: (h) => h(App),
    mounted() {}
}).$mount('#app')
window.app = app

// 错误收集
const ua = window.navigator.userAgent.toLowerCase()
// 上报后台错误信息
function report(error) {
    console.log(error)
}

removeAllPagePositions()

// 找到onerror错误
window.onerror = (msg, url, line) => {
    const _msg = '本页中存在错误。\n\n' + `错误：${msg}\n` + `URL: ${url}\n` + `行：${line}`
    report({
        type: 'window ERROR',
        message: _msg,
        ua,
        url: window.location.origin + store.getters.routerToPathSatate
    })
    return true // error不会以error形式打印到控制台
}

// promise rejecttion 错误捕获，promise错误需要单独捕获
window.addEventListener('unhandledrejection', (e) => {
    report({
        type: 'unhandledrejection',
        message: JSON.stringify(e),
        ua,
        url: window.location.origin + store.getters.routerToPathSatate
    })
    return true
})

// vue捕获的错误不会上报到window.error
Vue.config.errorHandler = errorHandler
const errorHandler = (error) => {
    console.log(error)
    report({
        type: 'Vue errorHandler',
        message: JSON.stringify(error),
        ua,
        url: window.location.origin + store.getters.routerToPathSatate
    })
}
Vue.prototype.$throw = (error) => errorHandler(error, this)
